import {ResultsTable} from 'notebook/integrations/results/ResultsTableConstants';
import {TableWithoutColumnWidths} from 'notebook/simple-tables/ManagedColumnsSimpleTableEditable';
import {getColumnLabel} from 'notebook/structured-tables/columns/ColumnDefinitions';
import toColumnConstraint from 'notebook/structured-tables/columns/toColumnConstraint';
import toColumnDefinition from 'notebook/structured-tables/columns/toColumnDefinition';
import {Cell, PLACEHOLDER_CELL} from 'notebook/tables/constants/CellConstants';

export const OVERSIZED_LAB_AUTO_RESULTS_TABLE_TOOLTIP = 'Table has too many rows to be expanded.';

export default function labAutoResultsTableToTable(resultsTable: ResultsTable): {
  table: TableWithoutColumnWidths;
  widths: Array<number>;
} {
  const structuredTableColumns = resultsTable.columns;
  const columnDefinitions = structuredTableColumns.map((structuredTableColumn) =>
    toColumnDefinition({structuredTableColumn, schemas: resultsTable.schemas, parentStorableIsGrid: false})
  );

  const tableRows: Array<Array<Cell>> = resultsTable.rows.length
    ? resultsTable.rows.map((row) => row.cells.map((cell) => ({...cell, locked: true})))
    : [resultsTable.columns.map((column, i) => PLACEHOLDER_CELL)];

  return {
    table: {
      defaultAffixedColumnCount: 1,
      allowAddRows: false,
      allowColumnEdits: false,
      allowNoRows: true,
      allowRowRemoval: false,
      columnConstraints: structuredTableColumns.map((structuredTableColumn) =>
        toColumnConstraint({
          structuredTableColumn,
          schemas: resultsTable.schemas,
          parentStorableIsGrid: false,
        })
      ),
      columnLabels: columnDefinitions.map((columnDefinition) => getColumnLabel(columnDefinition)),
      disallowCustomColumns: true,
      headerRow: false,
      headerCol: false,
      lockedDims: true,
      name: resultsTable.name,
      provenanceUuid: resultsTable.provenanceUuid,
      nameTooltip:
        !resultsTable.rows.length && resultsTable.metadata.numResults !== 0
          ? OVERSIZED_LAB_AUTO_RESULTS_TABLE_TOOLTIP
          : null,
      rowData: resultsTable.rows.map((row) => {
        const {cells, metadata, ...rowData} = row;
        return {...rowData, ...row.metadata};
      }),
      table: tableRows,
    },
    widths: structuredTableColumns.map(({width}) => width),
  };
}
